import { ARIValues, DailySet, ValueTypes } from "../../shared/types";
import { InventoryConfiguration } from "../../shared/domain/InventoryConfiguration";
import { AriType } from "../../updateForm";

export class BundleInventory implements ARIValues {
  ticker: string;
  name: string;
  parentTicker?: string;
  dailySet: DailySet[];
  valueType: ValueTypes;
  configuration: InventoryConfiguration;
  isChild: boolean;
  type: AriType;
  formula?: string;

  private constructor(
    ticker: string,
    name: string,
    configuration: InventoryConfiguration,
    parentTicker: string | undefined,
    dailySet: DailySet[],
    valueType: ValueTypes,
    isChild: boolean,
    formula?: string
  ) {
    this.ticker = ticker;
    this.name = name;
    this.configuration = configuration;
    this.parentTicker = parentTicker;
    this.dailySet = dailySet;
    this.valueType = valueType;
    this.isChild = isChild;
    this.type = AriType.BUNDLES;
    this.formula = formula;
  }

  static of(
    ticker: string,
    name: string,
    configuration: InventoryConfiguration,
    parentTicker: string | undefined,
    dailySet: DailySet[] | undefined,
    type: ValueTypes,
    isChild: boolean,
    formula?: string
  ): BundleInventory {
    return new BundleInventory(
      ticker,
      name,
      configuration,
      parentTicker,
      dailySet || [],
      type,
      isChild,
      formula
    );
  }
}
